<template>
  <div class="quotes" id="quotes">
    <Quotes :data="testimonials"></Quotes>
  </div>
</template>

<script>
import Quotes from '@/components/shared/Quotes';

export default {
  name: 'CustomerQuotes',
  components: {
    Quotes
  },
  props: ['screenSize'],
  created() {
    this.testimonials = {
      id: 'porsche-protection',
      title: '',
      paragraph: '',
      benefits: [
        {
          title: '',
          paragraph: `<p style="margin:0;">“I love the personal touch and that I only pay for the miles </p><p style="margin:0;">that I actually drive. That is how insurance should work!”</p>`,
          author:
            'Marc B., Customer since 2023 (911 C4 GTS, 718 Spyder, Cayenne Turbo GT)',
          image: 'quote_01',
          classes: {
            benefits_01: true
          },
          styling: {}
        },
        {
          title: '',
          paragraph: `<p style="margin:0;">“Start to finish the process was professional and polished.</p><p style="margin:0;">This is what I expect from the Porsche name.”</p>`,
          author:
            'Van T., Customer since 2020 (911 Cabriolet, 911 Coupe, Cayenne)',
          image: 'quote_02',
          classes: {
            quote_02: true
          },
          styling: {}
        },
        {
          title: '',
          paragraph: `<p style="margin:0;">“I appreciate the competitive pricing, but I would</p> <p style="margin:0;">stay even if my policy was more expensive</p> <p style="margin:0;">than 'regular' insurance. It is just better!”</p>`,
          author: 'Alice M., Customer since 2021 (Macan GTS)',
          image: 'quote_03',
          classes: {
            'image-3': true
          },
          styling: {
            'letter-spacing': '0.1rem',
            color: '#010205',
            top: '15%',
            float: 'right',
            'padding-right': '6rem',
            width: '100%',
            'text-align': 'right',
            'font-family':
              'PorscheNextRegular, "Arial Narrow", Arial, sans-serif',
            'font-weight': 600
          }
        }
      ],
      references: []
    };
  },
  computed: {
    size() {
      return this.$mq.media;
    }
  },
  data: () => ({
    testimonials: null
  })
};
</script>

<style lang="scss" scoped>
.quotes {
  background-color: #eff0f1;
}
.title {
  color: $black;
}
.quote-section {
  min-height: 0;
  color: $black;
  padding: $--pcom-spacing-large 0 $--pcom-spacing-x-large;
}

.reference-numbers {
  font-size: 0.8rem;
  padding-top: 0.5rem;
}

.secondary-title {
  font-family: $family-sans-serif;
  font-size: 2.25rem;
  padding: 0 0 10px;

  @media (max-width: 986px) {
    font-size: 1.75rem;
    line-height: 28px;
  }
}

.subtitle {
  font-size: 1.25rem;
  line-height: 24px;
  margin: 0 !important;
  padding: 20px 20px 10px;
  color: $black;

  @media (min-width: 768px) {
    line-height: 30px;
  }

  @include from($tablet) {
    font-size: 1.4rem;
  }

  @include until($widescreen) {
    font-size: 1.4rem;
  }

  @media (min-width: 1200px) {
    font-size: 1.5rem;
  }
}

.container {
  position: relative;
  .carousel-icon {
    font-size: 3rem;
    display: block;
    @media (max-width: 768px) {
      display: none;
    }
  }
  .icon--arrow-left-hair {
    left: 5%;
    top: 25%;
    @media (max-width: 1400px) {
      left: 2%;
    }
  }
  .icon--arrow-right-hair {
    right: 5%;
    top: 25%;
    @media (max-width: 1400px) {
      right: 2%;
    }
  }
}

.section {
  color: $black;

  @media (min-width: 1200px) {
    margin: 0;
  }
  @media (max-width: 479px) {
    padding: 10px 0 30px;
  }
  min-height: 0;
}

.d-row {
  display: flex;
  flex-direction: row;
}

.d-col {
  display: flex;
  flex-direction: column;
}
</style>
